import {
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Collapse,
    Dialog,
    DialogContent,
    Grid,
    MenuItem,
    Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useCreateContractBulk } from "../../../hooks/data/data_contract";
import { IContractState } from "../../../interfaces/IContractState";
import { IContractType } from "../../../interfaces/IContractType";
import { ICreateContract } from "../../../interfaces/ICreateContract";
import { ICreateContractBulk } from "../../../interfaces/ICreateContractBulk";
import { ICustomer } from "../../../interfaces/ICustomer";
import { IOffer } from "../../../interfaces/IOffer";
import { IPartner } from "../../../interfaces/IPartner";
import { IProject } from "../../../interfaces/IProject";
import { useSnackbar } from "../../context/SnackbarContext";
import { CustomeTextField } from "../../core/CustomeTextField";

interface IProps {
    contractType: IContractType;
    project: IProject;
    contractStateArray: IContractState[];
    offerArray: IOffer[];
    customerArray: ICustomer[];
    partnerArray: IPartner[];
    handleSave: () => void;
    handleClose: () => void;
}

export const AddContracts: React.FC<IProps> = ({
    contractType,
    project,
    offerArray,
    customerArray,
    partnerArray,
    handleSave,
    handleClose,
}) => {
    const { showFeedback } = useSnackbar();
    const { createContractBulk, isPendingCreateContractBulk } = useCreateContractBulk();

    const [formValues, setFormValues] = useState<ICreateContract>({
        ContractType: contractType.id,
        Customer: null,
        Partner: null,
        payload_id: null,
    } as ICreateContract);

    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        e.stopPropagation();

        try {
            const uploadObject: ICreateContractBulk = {
                Project: project.id,
                CreateContractArray: [formValues],
            };

            await createContractBulk(uploadObject);

            showFeedback("Die Verträge wurden erstellt!", "success");
            handleSave();
        } catch (error) {
            console.error(error);
            showFeedback("Es ist ein Fehler aufgeretten!", "error");
        }
    };

    return (
        <>
            <Dialog open maxWidth="md" fullWidth onClose={handleClose}>
                <DialogContent>
                    <form onSubmit={onSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography variant="h6">Neuer Vertrag</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Card variant="outlined">
                                    <Typography sx={{ m: 1 }} variant="caption">
                                        {contractType.contractType}
                                    </Typography>
                                    <CardContent>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <CustomeTextField
                                                    attr="payload_id"
                                                    label="Vertrag zum folgenden Angebot"
                                                    object={formValues}
                                                    setObject={setFormValues}
                                                    type="select"
                                                    required
                                                    null
                                                    disableNoValueOption
                                                >
                                                    {offerArray.map((offer) => (
                                                        <MenuItem key={`offfer-${offer.id}`} value={offer.id}>
                                                            {offer.title}{" "}
                                                            {offer.OfferType !== 3 && " (nicht angenommen!)"}
                                                        </MenuItem>
                                                    ))}
                                                </CustomeTextField>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Collapse in={formValues.payload_id !== null}>
                                                    {contractType.isContractWithCustomer ? (
                                                        <CustomeTextField
                                                            attr="Customer"
                                                            label="Kunde"
                                                            object={formValues}
                                                            setObject={setFormValues}
                                                            type="select"
                                                            required
                                                            null
                                                            disableNoValueOption
                                                        >
                                                            {project.Participant.filter((x) => x.is_contact_person).map(
                                                                (part) => {
                                                                    let customer = customerArray.find(
                                                                        (x) => x.id === part.Customer,
                                                                    );
                                                                    if (!customer) {
                                                                        <MenuItem>Error</MenuItem>;
                                                                    }
                                                                    return (
                                                                        <MenuItem
                                                                            key={`Participant-${part.Customer}`}
                                                                            value={part.Customer}
                                                                        >
                                                                            {customer?.firstname} {customer?.lastname}
                                                                        </MenuItem>
                                                                    );
                                                                },
                                                            )}
                                                        </CustomeTextField>
                                                    ) : (
                                                        <CustomeTextField
                                                            attr="Partner"
                                                            label="Partner"
                                                            object={formValues}
                                                            setObject={setFormValues}
                                                            type="select"
                                                            required
                                                            null
                                                            disableNoValueOption
                                                        >
                                                            {partnerArray.map((partner) => (
                                                                <MenuItem
                                                                    key={`partner-${partner.id}`}
                                                                    value={partner.id}
                                                                >
                                                                    {String(
                                                                        partner.Contact_Person?.Company?.company_name,
                                                                    )}
                                                                </MenuItem>
                                                            ))}
                                                        </CustomeTextField>
                                                    )}
                                                </Collapse>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12}>
                                <Box sx={{ float: "right" }}>
                                    <Button variant="outlined" onClick={handleClose}>
                                        Abbruch
                                    </Button>
                                    <Button
                                        variant="contained"
                                        disabled={isPendingCreateContractBulk}
                                        type="submit"
                                        sx={{ ml: 2 }}
                                    >
                                        {isPendingCreateContractBulk ? (
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <span>Erstellen</span>
                                                <CircularProgress size={20} />
                                            </Box>
                                        ) : (
                                            "Erstellen"
                                        )}
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
            </Dialog>
        </>
    );
};
